import script from "./submit2.vue?vue&type=script&setup=true&lang=js"
export * from "./submit2.vue?vue&type=script&setup=true&lang=js"

import "./submit2.vue?vue&type=style&index=0&id=a88c0b12&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a88c0b12"]])

export default __exports__